// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"349039a9","455":"8aba354c","977":"1ef88b33"}[chunkId] + ".chunk.js";
};